import { ShieldCheck, Moon, Sparkles, Home } from 'lucide-react';
import SpiracleLogo from '../../img/spiracle_logo.png';
import CTA from '../Cta';

function CooktopRepairService() {
    return (
        <div className="chimney-repair-container">
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Bed Bug Control Services</h1>
                    <p className="chimney-repair-subtitle">
                        Say goodbye to sleepless nights. Our effective odorless spray treatment eliminates bed bugs completely from your home, mattress and furniture.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Bed bugs cause irritation, itching and inflammation while you sleep. Our professional treatment stops the bites and ensures a peaceful night's sleep.
                    </p>
                    <p className="chimney-repair-subtitle">
                        The treatment maintains hygiene in your home and saves you from the embarrassment of bed bug infestations.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Our trained professionals treat every hiding spot - mattress seams, bed frames, sofas, curtains and wall crevices.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:8530352444")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={SpiracleLogo} alt="Bed Bug Control" />
            </div>

            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Bed Bug Treatment?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Moon size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Peaceful Sleep</h3>
                            <p className="chimney-repair-description">
                                Prevents bed bug bites and ensures a peaceful night sleep for your family.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Sparkles size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">No Itching</h3>
                            <p className="chimney-repair-description">
                                Stops itching and inflammation caused by bed bug bites completely.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Home size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Hygienic Home</h3>
                            <p className="chimney-repair-description">
                                Maintains hygiene and saves embarrassment with effective treatment.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <ShieldCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Odorless & Safe</h3>
                            <p className="chimney-repair-description">
                                Odorless spray treatment, safe for your family and pets.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Bed Bug Treatment Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Inspection</h3>
                        <p className="chimney-repair-step-description">
                            Thorough inspection of beds, mattresses, sofas, curtains and crevices to identify bed bug hiding spots.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Treatment Plan</h3>
                        <p className="chimney-repair-step-description">
                            We identify the infestation level and plan the right treatment strategy for your home.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Odorless Spray</h3>
                        <p className="chimney-repair-step-description">
                            Professional odorless spray treatment of all infested areas, including mattresses and furniture.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Post Treatment Advice</h3>
                        <p className="chimney-repair-step-description">
                            We guide you on cleaning and precautions after treatment to prevent re-infestation.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default CooktopRepairService;